import { apiJson } from './api';

const TOKEN_KEY = 'auth_token';

export interface AuthUser {
  id: string;
  name: string;
  email: string;
  role: string;
}

export interface AuthResponse {
  user: AuthUser;
  token?: string;
}

export interface LoginCredentials {
  username: string;
  password: string;
}

export function getStoredToken(): string | null {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setStoredToken(token: string): void {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearStoredToken(): void {
  localStorage.removeItem(TOKEN_KEY);
}

export async function login(credentials: LoginCredentials): Promise<AuthResponse> {
  const data = await apiJson<{ user: AuthUser; token: string }>('/api/mobile/auth/signin', {
    method: 'POST',
    body: JSON.stringify({
      username: credentials.username.trim(),
      password: credentials.password,
    }),
  });
  if (data.token) setStoredToken(data.token);
  return { user: data.user, token: data.token };
}

export async function verifyToken(token: string): Promise<AuthUser | null> {
  try {
    const data = await apiJson<{ valid?: boolean; user?: AuthUser }>('/api/mobile/auth/verify', {
      method: 'POST',
      body: JSON.stringify({ token }),
    });
    if (data.valid && data.user) return data.user;
    return null;
  } catch {
    return null;
  }
}

export function logout(): void {
  clearStoredToken();
}

export async function changePassword(currentPassword: string, newPassword: string): Promise<void> {
  await apiJson<{ success: boolean }>('/api/mobile/auth/change-password', {
    method: 'POST',
    body: JSON.stringify({
      currentPassword,
      newPassword,
    }),
  });
}
